let apiBase = (process.env.VUE_APP_API_BASE || '').replace(/\/+$/, '')

// Default to same-origin with "/apis" path instead of using an "apis." subdomain
if (!apiBase) {
  if (typeof window !== 'undefined' && window.location) {
    const { origin } = window.location
    apiBase = `${origin}/apis`
  } else {
    // Fallback for non-browser contexts
    apiBase = '/apis'
  }
}
export default {
  uri: apiBase,
  // uri: 'http://localhost:7443/apis',
  // uri: 'https://unibank.tval.online/apis',
  version: '1.1.5',

  // Dev-only: allow using MSAL tokens as app accessToken when backend returns null
  // Useful on localhost while backend Azure exchange is not wired.
  devAllowMsalTokenAsAccess: true,
  // Azure AD config (make it easy to switch tenants/apps)
  azureTenantId: '007a413b-442f-455f-aabd-aad7e9c68820',
  azureClientId: '67d418eb-ca04-49e8-935c-5167ce2d20de',
  // The Application ID URI of your protected API
  azureApiAppIdUri: 'api://67d418eb-ca04-49e8-935c-5167ce2d20de',
  // The scope name exposed by your API (e.g., 'user_impersonation')
  azureApiScopeName: 'user_impersonation',
}
